<script setup lang="ts">
import CrossIcon from '@/assets/icons/cross-icon.svg?raw';
withDefaults(defineProps<{onClose: Function, location?: 'gl-showcase' | 'notification' | 'default'}>(), {
    location: 'default',
});
</script>

<template>
    <div class="close" @click.prevent.stop="onClose()" v-mobile :data-location="location" v-html="CrossIcon"></div>
</template>

<style lang="scss" scoped>
@use '@/scss/shared';
.close{
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    line-height: 0;
    font-weight: 500;
    cursor: pointer;
    z-index: 0;
    overflow: hidden;
    transition: color .25s;
    &[data-location="default"],
    &[data-location="gl-showcase"]{
        font-size: 45px;
        width: 50px;
        height: 50px;
        right: -50px;
        top: -50px;
        @include shared.site() using($site-key){
            background-color: shared.theme-color('comp3_4', $site-key);
        }
    }
    &[data-location="notification"]{
        font-size: 30px;
        width: 36px;
        height: 36px;
        right: 0;
        top: -50px;
        @include shared.site() using($site-key){
            background-color: shared.theme-color('comp3_3', $site-key);
        }
    }
    &[data-mobile]{
        width: 36px;
        height: 36px;
        font-size: 30px;
        &[data-location="default"]{
            right: 0px;
            top: -26px;
        }
        &[data-location="gl-showcase"]{
            right: 0px;
            top: -50px;
        }
        &[data-location="notification"]{
            right: 0;
            top: -50px;
        }
    }
}
</style>